import { FC } from 'react';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

import { DashboardGranularity } from '__generated__/GQL';
import type { TooltipRangeDate } from 'features/Dashboard/common';
import { tooltipDateFormatter } from 'features/Dashboard/common';

import useIntervalContext from '../../hooks/useIntervalContext';
import GraphTooltip from '../GraphTooltip';

const formatLabel = ({
  day,
  granularity,
  year,
}: TooltipRangeDate & { granularity: DashboardGranularity }): string => {
  let label = day;

  if (granularity === DashboardGranularity.Month) {
    label += ` ${year}`;
  }

  return label;
};

const LineGraphTooltip: FC<TooltipProps<ValueType, NameType>> = ({
  ...props
}) => {
  const { granularity } = useIntervalContext();
  const { active, payload } = props;

  if (!active || !payload || !payload.length) {
    return null;
  }

  // @ts-expect-error Object is possibly 'undefined'.
  const newDates = tooltipDateFormatter(payload[0].payload.newDate);
  const firstLabel = formatLabel({ ...newDates, granularity });
  // @ts-expect-error Object is possibly 'undefined'.
  const firstAmount = payload[0].payload.newValue;

  // @ts-expect-error Object is possibly 'undefined'.
  const oldDates = tooltipDateFormatter(payload[0].payload.oldDate);
  const secondLabel = formatLabel({ ...oldDates, granularity });
  // @ts-expect-error Object is possibly 'undefined'.
  const secondAmount = payload[0].payload.oldValue;

  return (
    <GraphTooltip
      labels={[
        { title: firstLabel, value: firstAmount },
        { title: secondLabel, value: secondAmount },
      ]}
      {...props}
    />
  );
};

export default LineGraphTooltip;
